import { AiAssistantAudience as e } from "../starters/AiAssistantAudience.mjs";
import { useTranslation as t } from "@maat/store-i18n";
import { AiPageKind as n } from "@maat/api-ai/types";
//#region src/hooks/useAiStarterPrompts.ts
var r = (r, i) => {
	let { t: a } = t("search"), { t: o } = t("common");
	switch (r) {
		case e.Host: return {
			greeting: a("assistant.host.greeting"),
			prompts: [
				a("assistant.host.prompts.pending"),
				a("assistant.host.prompts.earnings"),
				a("assistant.host.prompts.trends"),
				a("assistant.host.prompts.reviews")
			],
			placeholder: a("assistant.host.composerPlaceholder")
		};
		case e.Admin: return {
			greeting: o("ai.adminGreeting"),
			prompts: [
				o("ai.adminSuggestionSummary"),
				o("ai.adminSuggestionTrends"),
				o("ai.adminSuggestionCancellations"),
				o("ai.adminSuggestionFinance")
			],
			placeholder: o("ai.adminInputPlaceholder")
		};
		case e.Guest: return i === n.Booking ? {
			greeting: a("assistant.booking.greeting"),
			prompts: [
				a("assistant.booking.prompts.checkIn"),
				a("assistant.booking.prompts.cancel"),
				a("assistant.booking.prompts.paid"),
				a("assistant.booking.prompts.status")
			],
			placeholder: a("assistant.booking.composerPlaceholder")
		} : i === n.Listing ? {
			greeting: a("assistant.listing.greeting"),
			prompts: [
				a("assistant.listing.prompts.availability"),
				a("assistant.listing.prompts.pets"),
				a("assistant.listing.prompts.cancellation"),
				a("assistant.listing.prompts.checkIn")
			],
			placeholder: a("assistant.listing.composerPlaceholder")
		} : {
			greeting: a("assistant.greeting"),
			prompts: [
				a("assistant.prompts.beachfront"),
				a("assistant.prompts.quiet"),
				a("assistant.prompts.family"),
				a("assistant.prompts.walkable")
			],
			placeholder: a("assistant.composerPlaceholder")
		};
	}
};
//#endregion
export { r as useAiStarterPrompts };
